import React, { useState, useEffect } from 'react';

const STORAGE_KEY = 'dichtlicht_auth';
const TOKEN_KEY = 'dichtlicht_site_token';

function PasswordProtection({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if already authenticated via stored token
    const storedToken = sessionStorage.getItem(TOKEN_KEY);
    if (storedToken) {
      // Verify token with server
      verifyToken(storedToken);
    } else {
      setIsLoading(false);
    }
  }, []);

  const verifyToken = async (token) => {
    try {
      const res = await fetch('/api/site-auth/verify', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token })
      });
      if (res.ok) {
        setIsAuthenticated(true);
      } else {
        sessionStorage.removeItem(TOKEN_KEY);
        sessionStorage.removeItem(STORAGE_KEY);
      }
    } catch (e) {
      // Bei Netzwerkfehler: Token behalten falls gesetzt
      if (sessionStorage.getItem(STORAGE_KEY) === 'true') {
        setIsAuthenticated(true);
      }
    }
    setIsLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    try {
      const res = await fetch('/api/site-auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password })
      });
      
      const data = await res.json();
      
      if (res.ok && data.success) {
        sessionStorage.setItem(STORAGE_KEY, 'true');
        sessionStorage.setItem(TOKEN_KEY, data.token);
        setIsAuthenticated(true);
      } else {
        setError(data.message || 'Falsches Passwort');
        setPassword('');
      }
    } catch (err) {
      setError('Verbindungsfehler');
    }
  };

  if (isLoading) {
    return null;
  }

  if (isAuthenticated) {
    return children;
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logo}>💡</div>
        <h1 style={styles.title}>Dichtlicht</h1>
        <p style={styles.subtitle}>Preisvergleich für Grow-Equipment</p>
        
        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Passwort eingeben"
            style={styles.input}
            autoFocus
          />
          <button type="submit" style={styles.button}>
            Einloggen
          </button>
          {error && <p style={styles.error}>{error}</p>}
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  card: {
    background: 'rgba(255, 255, 255, 0.95)',
    borderRadius: '16px',
    padding: '48px 40px',
    textAlign: 'center',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
    maxWidth: '400px',
    width: '90%',
  },
  logo: {
    fontSize: '64px',
    marginBottom: '16px',
  },
  title: {
    margin: '0 0 8px 0',
    fontSize: '32px',
    fontWeight: '700',
    color: '#1a1a2e',
  },
  subtitle: {
    margin: '0 0 32px 0',
    fontSize: '14px',
    color: '#666',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  input: {
    padding: '14px 18px',
    fontSize: '16px',
    border: '2px solid #e0e0e0',
    borderRadius: '8px',
    outline: 'none',
    transition: 'border-color 0.2s',
    textAlign: 'center',
  },
  button: {
    padding: '14px 24px',
    fontSize: '16px',
    fontWeight: '600',
    color: '#fff',
    background: 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'transform 0.2s, box-shadow 0.2s',
  },
  error: {
    margin: '8px 0 0 0',
    color: '#e53935',
    fontSize: '14px',
    fontWeight: '500',
  },
};

export default PasswordProtection;
